import { maxChars } from './maxChars';

export const max10000Chars = maxChars(10000);
